<template>
  <div :class="containerClass">
    <label
        v-if="label"
        :for="uuid"
    >
      {{ label }}
      <span v-if="required"><sup>*</sup></span>
    </label>
    <input
        :placeholder="getPlaceholder"
        class="uk-input"
        :class="{ 'ws-input-error': hasError }"
        :value="modelValue"
        :id="uuid"
        v-bind="{
          ...$attrs,
          onInput: updateValue
        }"
    >
  </div>
</template>

<script>
import SetupFormComponent from "../features/SetupFormComponent.js";
import UniqueID from "../features/UniqueID.js";

export default {
  name: "BaseInput",
  props: {
    label: {
      type: String,
      default: ''
    },
    containerClass: {
      type: String,
      default: ''
    },
    modelValue: {
      type: [String, Number],
      default: ''
    },
    required: {
      type: Boolean,
      default: true
    },
    errorMessage: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  setup(props, context) {
    const {updateValue} = SetupFormComponent(props, context)
    const uuid = UniqueID().getID()

    return {
      updateValue,
      uuid
    }
  },
  computed: {
    hasError() {
      return (this.errorMessage)
    },
    getPlaceholder() {
      if(this.placeholder != '') {
        return this.placeholder
      }
      return ''
    }
  }
}
</script>

